import Modal from "@mui/material/Modal";
import EsfirusButtonNative from "@components/ui/Button/EsfirusButtonNative";

interface ModalConfirmProps {
  open: boolean;
  onClose: () => void;
  onClick: Function;
  textHeader: string;
  description: string;
  className?: string;
  isLoading: boolean;
}

export const ModalConfirmarOpenClose = ({ open, onClose, onClick, textHeader, description, className, isLoading }: ModalConfirmProps) => {
  return (
    <Modal
      open={open}
      onClose={() => isLoading ? null : onClose()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className={className + " new-confirm-modal"}>
        <div className="header">
          <h5 className="text-center">
            {textHeader}
          </h5>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 4, padding: 16 }}>
          <div style={{ textAlign: "center", fontSize: 20, margin: "16px 0" }}>
            {isLoading ? "Realizando la acción ..." : description}
          </div>

          <div style={{ display: "flex", justifyContent: "center", gap: 16, margin: "16px 0" }}>
            <EsfirusButtonNative
              click={onClick}
              label={"Confirmar"}
              className={className ?? "secondary"}
              disabled={isLoading}
            />
            <EsfirusButtonNative
              click={() => onClose()}
              label={"Cancelar"}
              disabled={isLoading}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}